import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ExtraData {
  extraId?: number;
  extraName: string;
  extraPrice: number | null;
}

export interface OptionGroupData {
  groupName: string;
  groupDescription: string;
  minSelect: number;
  maxSelect: number;
  extras: ExtraData[];
}

export interface AvailableGroup {
  optionId: number;
  groupName: string;
  groupDescription?: string;
  minSelect?: number;
  maxSelect?: number;
  extras?: ExtraData[];
}

export interface NewItemData {
  name: string;
  description: string;
  price: number | null;
  vatRate?: number | null;
  categoryName: string;
  availableGroups?: AvailableGroup[];
  selectedGroupIds?: number[];
}

@Component({
  selector: 'app-add-item-dialog',
  standalone: false,
  templateUrl: './add-item-dialog.component.html',
  styleUrl: './add-item-dialog.component.scss',
})
export class AddItemDialogComponent {
  availableGroups: AvailableGroup[] = [];
  selectedGroupIds: number[] = [];

  vatRateOptions = [20, 17.5, 15, 0];

  constructor(
    private dialogRef: MatDialogRef<AddItemDialogComponent, NewItemData>,
    @Inject(MAT_DIALOG_DATA) public data: NewItemData,
  ) {
    this.availableGroups = data.availableGroups ?? [];
    this.selectedGroupIds = [...(data.selectedGroupIds ?? [])];

    if (this.data.vatRate == null) {
      this.data.vatRate = 20;
    }
  }

  save(): void {
    this.dialogRef.close({
      ...this.data,
      selectedGroupIds: this.selectedGroupIds,
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  get selectedGroupsPreview(): AvailableGroup[] {
    return this.availableGroups.filter((group) =>
      this.selectedGroupIds.includes(group.optionId),
    );
  }
}
